import { render, staticRenderFns } from "./ResourceFilter.vue?vue&type=template&id=8de4eef2"
import script from "./ResourceFilter.vue?vue&type=script&lang=js"
export * from "./ResourceFilter.vue?vue&type=script&lang=js"
import style0 from "./ResourceFilter.vue?vue&type=style&index=0&id=8de4eef2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports